import React from 'react';
import { Button } from './button';
import { LucideIcon } from 'lucide-react';

/**
 * IconButton - Botón solo con icono
 * Especializado para botones que solo muestran un icono sin texto
 */
export interface IconButtonProps {
  // Icono (opcional)
  icon?: LucideIcon;

  // Tooltip/label para accesibilidad
  'aria-label': string;
  title?: string; // Tooltip visual

  // Acción al hacer click
  onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;

  // Variante visual
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger';

  // Tamaño
  size?: 'sm' | 'md' | 'lg';

  // Estado
  disabled?: boolean;
  loading?: boolean;

  // Estilos adicionales
  className?: string;

  // Tipo de botón
  type?: 'button' | 'submit' | 'reset';
}

export const IconButton: React.FC<IconButtonProps> = ({
  icon: Icon,
  'aria-label': ariaLabel,
  title,
  onClick,
  variant = 'ghost',
  size = 'md',
  disabled = false,
  loading = false,
  className = '',
  type = 'button',
}) => {
  const getSizeClasses = (size: string) => {
    switch (size) {
      case 'sm':
        return 'h-8 w-8 p-0';
      case 'md':
        return 'h-10 w-10 p-0';
      case 'lg':
        return 'h-12 w-12 p-0';
      default:
        return 'h-10 w-10 p-0';
    }
  };

  const getIconSize = (size: string) => {
    switch (size) {
      case 'sm':
        return 'h-4 w-4';
      case 'md':
        return 'h-5 w-5';
      case 'lg':
        return 'h-6 w-6';
      default:
        return 'h-5 w-5';
    }
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={onClick}
      disabled={disabled || loading}
      type={type}
      className={`${getSizeClasses(size)} ${className}`}
      aria-label={ariaLabel}
      title={title || ariaLabel}
    >
      <Icon className={getIconSize(size)} />
    </Button>
  );
};

export default IconButton;
